import { BarChartOutlined, GroupOutlined, MessageOutlined, ShakeOutlined, ShopOutlined, UserOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import RoutePath from "../../app/routing/routes.path";
import { useEffect, useState } from "react";

const items = [
    {
        key: "query",
        icon: (<MessageOutlined />),
        label: (<NavLink to={RoutePath.query}>Query</NavLink>)
    },
    // {
    //     key: "deviceType",
    //     icon: (<GroupOutlined />),
    //     label: (<NavLink to={RoutePath.deviceType}>Device Type</NavLink>)
    // },
    {
        key: "user",
        icon: (<UserOutlined />),
        label: (<NavLink to={RoutePath.user}>User</NavLink>)
    },
    {
        key: "kpi",
        icon: (<BarChartOutlined />),
        label: (<NavLink to={RoutePath.kpi}>KPI</NavLink>)
    },
]
export default function MasterMenu() {
    let location = useLocation();
    const [selected, setSelected] = useState(['']);

    useEffect(() => {
        let s = location.pathname.split('/').filter(p=>!!p)
        setSelected(s);
    }, [location]);

    return (<Menu theme="dark" items={items} mode="horizontal" selectedKeys={selected}></Menu>)
}